export const createFingerprintRepository = (appFetch) => {
    return {
        send(body, options = {}) {
            return appFetch.post('/cabinet/ajax/set-fingerprint', body, options);
        },
    };
};
